module.exports = __webpack_public_path__ + "img/rfid-icon.bce47a26.svg";